import { Entity } from '@inter-ikea-core/core';
import { CustomComponentIds } from '@inter-ikea-kvadrat/kvadrat';
import { BehaviorParameters } from 'rangeConfig/@types';

const addCornerFrame = ({ coreApi, props }: BehaviorParameters) => {
  const cornerEntities = props.position
    ? ([
        coreApi.entities.getEntityClosestToPosition(props.position, [
          CustomComponentIds.ROOM_CORNER_COMPONENT_ID
        ])
      ].filter(Boolean) as Entity[])
    : coreApi.entities.getByComponent(CustomComponentIds.ROOM_CORNER_COMPONENT_ID);

  for (let i = 0; i < cornerEntities.length; i++) {
    const placementResult = coreApi.products.addToTarget(props.coreProductId, cornerEntities[i]);
    if (placementResult.placedEntity) break;
  }
};

export default addCornerFrame;
